export function Admin() {
  return (
    <div>
      <h1 style={{ marginTop: 0 }}>Admin</h1>
      <p style={{ color: '#9ca3af', maxWidth: 640 }}>
        Wrapper, model, and connector CRUD. This is the admin console — only
        accessible to users with the <code>admin</code> role.
      </p>
      <div style={{
        marginTop: '2rem',
        padding: '1.25rem 1.5rem',
        border: '1px solid rgba(127, 127, 127, 0.2)',
        borderRadius: 10,
        background: 'rgba(127, 127, 127, 0.04)',
      }}>
        <h3 style={{ marginTop: 0, fontSize: '0.95rem' }}>Admin features coming next</h3>
        <ul style={{ margin: 0, color: '#9ca3af', lineHeight: 1.8 }}>
          <li>Wrapper CRUD — create / edit / disable wrappers and their model pools</li>
          <li>Model adoption — review Decision Brain proposals, adopt or reject</li>
          <li>Connector management — install new connector packs, update KB</li>
          <li>Telemetry — per-(wrapper × model) leaderboard, latency, success rate</li>
        </ul>
      </div>
    </div>
  );
}
